import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { updateMe, UpdateMeRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useUpdateMe = ({
  navigate = true,
  withSuccessMsg = true,
}: { navigate?: boolean; withSuccessMsg?: boolean } = {}) => {
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: UpdateMeRequest) => {
      return updateMe(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["my-user"] });

      withSuccessMsg && openToast({ variant: "success", message: "Settings updated!" });
      navigate && push("/platform/settings");
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useUpdateMe };
